<template>
  <div class="squareDivImgWrap" ref="squareDivImgWrap">
    <img :src="imgSrc" class="imgSrc" :style="addStyle"/>
    <ul class="squareList">
      <li 
        v-for="item in squareList" 
        :key="item.id"
        :style="{width: w + 'px', height: h + 'px'}"
      ></li>
    </ul>
  </div>
</template>

<script>
import { squareList } from './data'

export default {
  name: 'squareDivImg',
  props: {
    imgSrc: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false
    },
    addStyle: {
      type: String,
      default: '',
    }
  },

  watch: {
    show ( show ) {
      if ( show ) {
        let t = setTimeout( () => {
          clearTimeout(t)
          this.init()
        }, 100 )
        
      }
    }
  },
  
  data () {
    return {
      w: 0, // 白色方块的宽度
      h: 0, // 白色方块的高度
      squareList,
    }
  },
  mounted () {
    
  },
  methods: {
    init () {
      let info = this.$refs.squareDivImgWrap.getBoundingClientRect()
      let { width, height } = info
      // let w = width / 5
      // let h = height / 3
      this.w = width / 5
      this.h = height / 3
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './squareDivImg.styl'
</style>